import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';

// Store
import { loadTimezones, loadTimezonesSuccess, loadTimezonesError } from './timezones.actions';

// Services
import { TimezoneService } from '@services/timezone.service';

@Injectable()
export class TimezonesEffects {
  private actions$ = inject(Actions);
  private timezoneService = inject(TimezoneService);

  loadTimezones$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadTimezones),
      switchMap(() =>
        this.timezoneService.getTimezones().pipe(
          map(({ timezones }) => loadTimezonesSuccess({ timezones })),
          catchError(error => of(loadTimezonesError({ error }))),
        ),
      ),
    ),
  );
}
